export default __webpack_public_path__ + "img/LoadingPhone.ad82fc68.jpg";